export default "__VITE_ASSET__DAdIeRMw__"